/*
 * @Author: Latte
 * @Date: 2021-09-09 16:20:13
 * @LAstEditors: Latte
 * @LastEditTime: 2021-12-16 08:44:59
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\system\CSDocument\user.js
 */

import request from '@/utils/request'
import config from '@/utils/config'
import {handleUrlEncode} from "@/utils/urlutil";

/**
 * 获取注册用户列表
 *
 * @param {*} params
 */
export function getUserList(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/VRoleUserList',
		method: 'get',
		params,
	})
}

/**
 * 获取用户信息
 *
 * @param {*} params
 */
export function getUserInfo(params) {
	return request({
		url: config.API_MEDICAL + '/Api/V1/AdminDocuments/UserInfo',
		method: 'get',
		params,
	})
}

/**
 * 添加用户
 *
 * @param {*} data
 */
export function addUser(data) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/VipRoleUser/Add',
		method: 'post',
		data,
	})
}

/**
 * 删除用户
 *
 * @param {*} params
 */
export function deleteUser(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/RoleUser/Delete',
		method: 'delete',
		params,
	})
}

/**
 * 获取用户审核列表
 *
 * @param {*} params
 */
export function getUserReviewList(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/VipUserAuditList',
		method: 'get',
		params,
	})
}

/**
 * 更改用户审核状态
 *
 * @param {*} data
 */
export function reviewUser(data) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/VipRoleUser/Audit',
		method: 'post',
		data,
	})
}

/**
 * 删除用户审核
 * @param {*} data 
 */
export function deleteUserReview(csVipUserID) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/VipRoleUser/req/delete?csVipUserID=' + csVipUserID,
		method: 'delete'
	})
}

/**
 * 获取用户记录列表
 *
 * @param {*} params
 */
export function getUserRecordList(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/FileViewRecordList',
		method: 'get',
		params,
	})
}

/**
 * 获取用户角色列表
 *
 * @param {*} params
 */
export function getUserRoleList(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/FileRoleList',
		method: 'get',
		params,
	})
}

/**
 * 添加用户角色
 *
 * @param {*} data
 */
export function addUserRole(data) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/CsFileRole/add',
		method: 'post',
		data,
	})
}

/**
 * 编辑用户角色
 *
 * @param {*} data
 */
export function editUserRole(data) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/CsFileRole/Update',
		method: 'post',
		data,
	})
}

/**
 * 删除用户角色
 *
 * @param {*} params
 */
export function deleteUserRole(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/CsFileRole/Delete',
		method: 'delete',
		params,
	})
}

/**
 * 获取用户申请列表
 *
 * @param {*} params
 */
export function getUserRequestList(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/CsFileReadReqList',
		method: 'get',
		params,
	})
}

/**
 * 更改用户申请状态
 *
 * @param {*} data
 */
export function reviewUserApplication(data) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminDocuments/CsFileReadReq/Audit',
		method: 'post',
		data,
	})
}

/**
 *  (新版)分页查询客服模块角色列表
 *
 *  @param {*} data
 */
export function getCSRoleList(data) {
	return request({
		url: config.API_AUTH + '/auth/v1/role/cs/list',
		method: 'get',
		data,
	})
}

/**
 *  (新版)分页查询系统角色列表
 *
 *  @param {*} data
 */
export function getSystemRoleList(data) {
	return request({
		url: config.API_AUTH + '/auth/v1/role/list',
		method: 'get',
		data,
	})
}

/**
 *  (新版)分页查询客服模块角色列表
 *
 *  @param {*} data
 */
export function setCSRole(data) {
	return request({
		url: config.API_AUTH + '/auth/v1/role/cs/status',
		method: 'post',
		data,
	})
}

/**
 * 获取用户角色设备绑定信息
 * @param data
 * @returns {*}
 */
export function getCsRoleUserList(params) {
	let url = `${config.API_ADMIN}/Api/V1/AdminDocuments/CsRoleUserList?`
	url = handleUrlEncode(url,params)
	return request({
		url: url,
		method: "get",
	});

}

/**
 * 用户绑定角色
 * @param data
 * @returns {*}
 */
export function bindUserRoleDevice(data) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminUsers/Role/Bind',
		method: 'patch',
		data,
	})
}

/**
 * 检测用户
 */
export function inspectUser(data){
	return request({
		url: config.API_ADMIN +'/Api/V1/AdminUsers/User/Account?account='+data,
		method: 'get',
	})
}

/**
 * 查询某个角色资料类型
 */
export function getCsFileAccess(roleId){
	return request({
		url: config.API_ADMIN+'/Api/V1/AdminDocuments/Role/CsFileType/List?roleId='+roleId,
		method:'get',
	})
}

/**
 * 解除用户绑定角色
 * @param data
 * @returns {*}
 */
export function unbindUserRoleDevice(params) {
	const arr = [];
	Object.entries(params).forEach((item) => {
		arr.push(`${item[0]}=${encodeURIComponent(item[1])}`);
	});
	return request({
		url: `${config.API_ADMIN}/Api/V1/AdminUsers/Role/UnBind?${arr.join("&")}`,
		method: "delete",
	});
}

/**
 * 后台管理分页查询用户绑定设备记录
 * @param data
 * @returns {*}
 */
export function getUserSeriesVoList(params) {
	return request({
		url: `${config.API_ADMIN}/Api/V1/AdminDocuments/UserSeriesVoList`,
		method: "get",
		params
	});
}


